app.service('deliveryHomeAddressDetails', function (orderConfig, validate) {

	let $root, $self, $countryCode, $zipCode;
	let config;

	function init($deliveryForm, onCountryCodeChange) {
		config = orderConfig.getData();
		setElements();
		setEvents($deliveryForm, onCountryCodeChange);
	}

	function setElements() {

		$root = $('#container');
		$self = $('#home-address-details');
		$countryCode = $('#country-code', $self);
		$zipCode = $('#zip-code', $self);
	}

	function setEvents($form, onCountryCodeChange) {
		$countryCode.on('change', function handleCountryCodeChange() {
			validate.element($(this), $form);

			if ($zipCode.val().length) {
				validate.element($zipCode, $form);
			}

			const isPolishCountryCode = $(this).val() === 'PL';
			let isHomeDelivery;

			if (isPolishCountryCode) {
				if (isEmptyDeliveryData()) {
					isHomeDelivery = true;
					$('input[type=radio].js-delivery-home').val([true]); // ustaw Adres dostawy: Taki sam jak powyżej
				} else {
					isHomeDelivery = false;
					$('input[type=radio].js-delivery-home').val([false]); // zostawiamy Adres dostawy: Inny adres dostawy
				}
				$.cityAutocomplete('#zip-code', '#city-name', config.streetValidateEnable ? '#home-street' : false);
				$root.removeClass('hide-home-delivery-controls');
			} else {
				isHomeDelivery = false;
				$('input[type=radio].js-delivery-home').val([false]);  // wymuszenie Adres dostawy: Inny adres dostawy
				$.cityUnautocomplete('#zip-code', '#city-name', '#home-street');
				$root.addClass('hide-home-delivery-controls');
			}

			onCountryCodeChange(isHomeDelivery);

			setZipCode($(this).val());

			if (hasChangedPolishCountryCode($countryCode)) {
				$('#zip-code, #city-name, #home-street, #home-house-number ,#home-flat-number').val(''); // czyścimy dane adresowe
			}

			$(this).data('prev-value', $(this).val());
		});

		if ($countryCode.val() === 'PL') {
			$.cityAutocomplete('#zip-code', '#city-name', config.streetValidateEnable ? '#home-street' : false);
		}
	}

	function setZipCode(countryCode) {

		const isPolishCountryCode = countryCode === 'PL';
		const maxLength = isPolishCountryCode ? 6 : 8;
		const type = isPolishCountryCode ? 'tel' : 'text';
		const placeholder = isPolishCountryCode ? '_ _ - _ _ _' : '';

		$zipCode.filter(':not([type=hidden])').prop({
			'maxlength': maxLength,
			'type': type,
			'placeholder': placeholder
		});
	}

	function hasChangedPolishCountryCode($countryCode) {
		const previousValue = $countryCode.data('prev-value');
		const currentValue = $countryCode.val();

		if (previousValue === 'PL' && currentValue !== 'PL') {
			return true;
		}

		return previousValue !== 'PL' && currentValue === 'PL';
	}

	function isEmptyDeliveryData() {
		let $deliveryInputs = $('#delivery-zip-code, #delivery-city-name, #delivery-street, #delivery-house-number, #delivery-flat-number');

		return $deliveryInputs.filter(function () {
			return $(this).val() !== '';
		}).length === 0;
	}

	return {
		init
	};
});
